export default __webpack_public_path__ + "static/media/cfd3.6e0c4e81.png";